var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatistic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14.676 0H5.333C1.93 0 0 1.929 0 5.333v9.334C0 18.07 1.929 20 5.333 20h9.343C18.08 20 20 18.071 20 14.667V5.333C20 1.93 18.08 0 14.676 0Z",
    fill: "#878787"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.369 7.37a.833.833 0 0 0-.827.835v6.87a.83.83 0 0 0 1.662 0v-6.87a.835.835 0 0 0-.835-.836Zm4.667-3.281a.833.833 0 0 0-.827.835v10.151a.83.83 0 0 0 1.662 0V4.925a.835.835 0 0 0-.835-.836Zm4.604 6.907a.835.835 0 0 0-.835.835v3.245a.83.83 0 0 0 1.662 0V11.83a.833.833 0 0 0-.827-.835Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatistic);
export default __webpack_public_path__ + "static/media/ic_statistic.0f52eb5899a8121fccb91fcc481d0952.svg";
export { ForwardRef as ReactComponent };